import { computed, ComputedRef } from 'vue';
import { useQueryV2 } from '@libs/use';
import { Strategies } from '@libs/api-reference';

import * as API from '../requests';
import { OPTION_QUERY_KEYS } from '../constants';

type TUseOptionStrategiesQuery = {
  immediate?: ComputedRef<boolean> | boolean;
  shouldRefetch?: boolean;
};

export default function useOptionStrategiesQuery(
  { immediate, shouldRefetch }: TUseOptionStrategiesQuery = {
    immediate: true,
    shouldRefetch: false,
  }
) {
  const {
    result,
    status: getOptionStrategiesStatus,
    execute: getOptionStrategies,
    isPending: isLoadingOptionStrategies,
    isSuccess: isSuccessLoadingOptionStrategies,
    isError: isErrorLoadingOptionStrategies,
  } = useQueryV2<Strategies>(
    () => API.getOptionStrategies({ pageNumber: 1, pageSize: 100 }),
    {
      key: OPTION_QUERY_KEYS.strategies,
      refetchInterval: shouldRefetch ? 10000 : false,
      immediate,
    }
  );

  const optionStrategies = computed(() => {
    return result.value?.data.items || [];
  });

  return {
    optionStrategies,
    getOptionStrategiesStatus,
    getOptionStrategies,
    isLoadingOptionStrategies,
    isSuccessLoadingOptionStrategies,
    isErrorLoadingOptionStrategies,
  };
}
